import * as _ from 'lodash';
import React, { useState, useEffect, useContext } from 'react';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
import FindClientDialog from  'src/components/client-project/dialogs/FindClientDialog';
import { ITableConfig } from 'src/components/common/table';
import useFetch from 'use-http';
import CPNavBar from '../CPNavBar';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import { SelectItem } from 'src/models/common/SelectItem';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import TagContainer from 'src/components/counties/TagContainer';
import State from 'src/models/State';
import County from 'src/models/County';
import Button from 'src/components/controls/forms/redesign/FormButton';
import ClientProjectSearch from 'src/components/project-billing/components/ClientProjectSearch';
import PagedResultSet from 'src/models/common/PagedResultSet';
import TsdiClient from 'src/models/AP/Client';
import { BiAddToQueue, BiLeftArrowAlt, BiRightArrowAlt, BiArrowToLeft, BiArrowToRight } from 'react-icons/bi';
import { MdSubdirectoryArrowRight } from 'react-icons/md';
import { FaFileExcel } from 'react-icons/fa';
import { FaFileImport } from 'react-icons/fa';
import { FaFileExport } from 'react-icons/fa';
import { FaFileInvoiceDollar } from 'react-icons/fa';
import { FaRegSave } from 'react-icons/fa';
import { BsSearch } from 'react-icons/bs';
import { VscGraph } from 'react-icons/vsc';
import DialogList from 'src/dialogs';
import actions from 'src/actions';
import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import ProspectDetails from 'src/models/projectSettings/TsdiProspect';
import FindProjectDialog from '../dialogs/FindProjectDialog';
import { AiOutlineHistory } from 'react-icons/ai';
import AltSubCodeDialog from '../dialogs/AlternateSubCodeDialog';
import TsdiSubcode from 'src/models/AP/Subcode';
import FindSubcodeDialog from '../dialogs/FindSubcodeDialog';
import TsdiSubcodeType from 'src/models/AP/SubcodeType';
import AddAltSubcodeDialog from '../dialogs/AddAltSubcodeDialog';
import AltAndSubcodeBillingDialog from '../dialogs/SubcodeBillingDialog';
import TsdiAltOrSubcodeBilling from 'src/models/AP/AltOrSubcodeBilling';
import TsdiAltSubcode from 'src/models/AP/AltSubcode';
import InvoiceGroupSubcode from 'src/models/AP/InvoiceGroupSubcode';
import InvoiceGroupingDialog from '../dialogs/InvoiceGroupingDialog';
import WarningDialog from 'src/components/accounts-payable/dialogs/WarningDialog';
import TsdiInvoiceGroupRequest from 'src/components/project-billing/models/InvoiceGroupRequest';
import TsdiInvoiceGroup from 'src/components/project-billing/models/InvoiceGroup';
import EditInvoiceGroupNameDialog from 'src/components/project-billing/dialogs/EditInvoiceGroup';

const SubcodeMaintenancePage = () => {
    const dispatch = useDispatch();
    // const { get, post, del, put, response } = useFetch();
    // const { register, reset, setValue, getValues, handleSubmit, errors, formState } = useForm();
    const { register: registerState, /*reset: resetState*/ } = useForm();
    const { register, errors, reset, getValues, handleSubmit: handleSubcodeSubmit, formState} = useForm();
    const { register: registerClientValues, reset: resetClientValues } = useForm();
    const { get, post, put, response } = useFetch();
    const [projects, setProjects] = useState<ProspectDetails[]>(undefined);
    const [projectTypes, setProjectTypes] = useState<{ code: number, description: string}[]>(undefined);
    const [currentMileageRate, setCurrentMileageRate] = useState<number>(undefined);
    const [selectedState, setSelectedState] = useState<number>(undefined);
    const [clientStateId, setClientStateId] = useState<number>(undefined);
    const [clients, setClients] = useState<Array<TsdiClient>>(undefined);
    const [states, setStates] = useState<PagedResultSet<State>>(undefined);
    const [stateCounties, setStateCounties] = useState<PagedResultSet<County>>(undefined);
    const [selectStates, setSelectStates] =  useState<Array<{ value: string; label: string }>>(undefined);
    const [selectStateCounties, setSelectStateCounties] = useState<Array<SelectItem>>(undefined);
    const [clientSearchOptions, setClientSearchOptions] = useState<ODataOptions>(undefined);
    const [projectSearchOptions, setProjectSearchOptions] = useState<ODataOptions>(undefined);
    const [clientSearchTerm, setClientSearchTerm] = useState<string>('');
    const [projectSearchTerm, setProjectSearchTerm] = useState<string>('');
    const [fetchNextClientsPage, setFetchNextClientsPage] = useState<boolean>(true);
    const [fetchNextProjectsPage, setFetchNextProjectsPage] = useState<boolean>(true);
    const [selectedClient, setSelectedClient] = useState<TsdiClient>(undefined);
    const [selectedSubcodeType, setSelectedSubcodeType] = useState<string>(undefined);
    const [tsdiNumber, setTsdiNumber] = useState<number>(undefined);
    const [tsdiName, setTsdiName] = useState<string>(undefined);
    // Todo: convert this to SurveyTypes list to populate the Survey Types drop-down
    // const [surveyType, setSurveyType] = useState<number>(undefined);
    const [selectedProject, setSelectedProject] = useState<ProspectDetails>(undefined);
    const [selectedSubcode, setSelectedSubcode] = useState<TsdiSubcode>(undefined);
    const [closureRequest, setClosureRequest] = useState<{ groupNumber: number, cancelRequest: boolean, close: boolean}>(undefined);
    const [finalizeClosureRequest, setFinalizeClosureRequest] = useState<object>(undefined);
    const [subcodes, setSubcodes] = useState<Array<TsdiSubcode>>(undefined);
    const [subcodeTypes, setSubcodeTypes] = useState<Array<{value: string, label: string}>>(undefined);
    const [surveyTypes, setSurveyTypes] = useState<Array<{value: string, label: string}>>(undefined);
    const [addingSubcode, setAddingSubcode] = useState<boolean>(false);
    const [addingAltSubcode, setAddingAltSubcode] = useState<boolean>(false);
    const [findingAltSubcode, setFindingAltSubcode] = useState<boolean>(false);
    const [showBillingSettings, setShowBillingSettings] = useState<boolean>(false);
    const [altOrSubcodeBillingInfo, setAltOrSubcodeBillingInfo] = useState<TsdiAltOrSubcodeBilling>(undefined);
    const [invoiceGroupSubcodeSearchOptions, setInvoiceGroupSubcodeSearchOptions] = useState<ODataOptions>(new ODataOptions());
    const [igSubcodes, setIgSubcodes] = useState<Array<InvoiceGroupSubcode>>(undefined);
    const [saveCountiesRef, setSaveCountiesRef] = useState<HTMLButtonElement>(null);
    const [countiesForUpdate, setCountiesForUpdate] = useState<Array<County>>(null);
    const [openInvoiceGrouping, setOpenInvoiceGrouping] = useState<Object>(undefined);
    const [creatingGroup, setCreatingGroup] = useState<Array<InvoiceGroupSubcode>>(undefined);
    const [invoiceGroup, setInvoiceGroup] = useState<TsdiInvoiceGroup>(undefined);
    const [addSections, setAddSections] = useState<boolean>(undefined);
    const appContext = useContext<IAppContextState>(AppContext);
    // const { isDirty, dirtyFields } = formState;
    const { isDirty } = formState;

    // Initial render
    useEffect(() => {
        onCreate();

        return () => {
            onDestroy();
        };
    }, []);

    useEffect(() => {
        if (Array.isArray(creatingGroup)) {
            if (addSections) {
                const updateSections = normalizeInvoiceGroupSubcodes(_.cloneDeep(creatingGroup));
                setAddSections(false);
                updateInvoiceGroupSections(updateSections);
            }
        }
    }, [creatingGroup]);

    useEffect(() => {
        if (openInvoiceGrouping) {
            showDialog(DialogList.INVOICE_GROUPING);
        }
    }, [openInvoiceGrouping]);

    useEffect(() => {
        if (finalizeClosureRequest) {
            showDialog(DialogList.INVOICE_GROUPING);
        }
    }, [finalizeClosureRequest]);

    useEffect(() => {
        if (invoiceGroupSubcodeSearchOptions) {
            getInvoiceGroupSubcodes();
        }
    }, [invoiceGroupSubcodeSearchOptions]);

    useEffect(() => {
        if (!!clientSearchOptions) {
            getClients();
        }
    }, [clientSearchOptions]);

    useEffect(() => {
        if (!!subcodes && subcodes?.length > 0) {
            setSelectedSubcode(subcodes[0]);
        }
    }, [subcodes]);

    useEffect(() => {
        if (!!projectSearchOptions) {
            getProjects();
        }
    }, [projectSearchOptions]);

    useEffect(() => {
        if (!!countiesForUpdate && countiesForUpdate?.length > 0) {
            updateSubcode(generateSubcodeUpdatePayload());
        }
    }, [countiesForUpdate]);

    useEffect(() => {
        if (!!addingSubcode) {
            showDialog(DialogList.FIND_SUBCODE);
        }
    }, [addingSubcode]);

    useEffect(() => {
        if (!!addingAltSubcode) {
            showDialog(DialogList.FIND_ALTSUBCODE);
        }
    }, [addingAltSubcode]);

    useEffect(() => {
        if (!!findingAltSubcode) {
            showDialog(DialogList.FIND_ALTSUBCODE);
        }
    }, [findingAltSubcode]);

    useEffect(() => {
        if (!!showBillingSettings) {
            showDialog(DialogList.ALT_OR_SUBCODE_BILLING_DIALOG);
        }
    }, [showBillingSettings]);

    useEffect(() => {
        if (Array.isArray(igSubcodes) && igSubcodes.length > 0) {
            if (invoiceGroup && invoiceGroup.clientNumber && invoiceGroup.projectNumber) {
                const newInvoiceGroup = _.cloneDeep(invoiceGroup);
                newInvoiceGroup.prospectInvoiceGroup = igSubcodes.length + 1;
                setInvoiceGroup(newInvoiceGroup);
            }
        }
    }, [igSubcodes]);

    useEffect(() => {
        if (states?.items?.length) {

            let list = states?.items?.map(s => {
                return {
                    label: (!!s.name ? `(${s.name})` : ''),
                    value: `${s.id}` };
            });
            setSelectStates(list);
        }
    }, [states]);

    useEffect(() => {
        if (!!clients) {
            const storedClientNumber = localStorage.getItem('backOfficeSelectedClientNumber');
            if (!!storedClientNumber && !isNaN(Number(storedClientNumber))) {
                const clientToSelect = clients.find((c) => c.clientNumber === Number(storedClientNumber));
                if (!!clientToSelect) {
                    setSelectedClient(clientToSelect);
                }
            }
        }
    }, [clients]);

    useEffect(() => {
        if (!!projects && projects?.length > 0) {
            const storedProjectNumber = localStorage.getItem('backOfficeSelectedProjectNumber');
            if (!!storedProjectNumber && !isNaN(Number(storedProjectNumber))) {
                const projectToSelect = projects.find((p) => p.number === Number(storedProjectNumber));
                if (!!projectToSelect) {
                    setSelectedProject(projectToSelect);
                }
            }
        }
    }, [projects]);

    useEffect(() => {
        if (!!selectStates) {
            console.log(selectStates[0]);
        }
    }, [selectStates]);

    useEffect(() => {
        if (!!stateCounties && stateCounties?.items?.length > 0) {
            setSelectStateCounties(stateCounties ? stateCounties?.items?.map((c: County) => new SelectItem(c.id, c.name)) : undefined);
        }
    }, [stateCounties]);

    useEffect(() => {
        if ((!!clientSearchTerm || clientSearchTerm === '') && !!clientSearchOptions) {
            resetClientSearchOptions();
        }
    }, [clientSearchTerm]);

    useEffect(() => {
        if ((!!projectSearchTerm || projectSearchTerm === '') && !!projectSearchOptions) {
            resetProjectSearchOptions();
        }
    }, [projectSearchTerm]);

    useEffect(() => {
        getClients();
    }, [clientSearchOptions]);

    useEffect(() => {
        if (!!clients && clients.length > 0) {
            prepFormData();
            getStatesCounties(clientStateId);
        }
    }, [clients]);

    useEffect(() => {
        if (!!selectedClient) {
            const storedProjectNumber = localStorage.getItem('backOfficeSelectedProjectNumber');
            const storedProjectName = localStorage.getItem('backOfficeSelectedProjectName');
            if (!!storedProjectNumber && !isNaN(Number(storedProjectNumber)) && !!storedProjectName) {
                getProject(selectedClient.clientNumber, Number(storedProjectNumber));
            }
            resetClientValues({
                clientNumber: selectedClient.clientNumber,
                clientName: selectedClient.clientName,
                projectNumber: !!selectedProject?.number ? selectedProject?.number : '',
                projectName: !!selectedProject?.name ? selectedProject?.name : ''
            });
            getStatesCounties(clientStateId);
        }
    }, [selectedClient]);

    useEffect(() => {
        if (!!selectedSubcode) {
            populateSubcodeForm(selectedSubcode);
            getBillingInfo();
        }
    }, [selectedSubcode]);

    useEffect(() => {
        if (!!selectedProject) {
            if (!!selectedClient?.clientNumber && !!selectedClient?.clientName) {
                resetClientValues({
                    clientNumber: selectedClient.clientNumber,
                    clientName: selectedClient.clientName,
                    projectNumber: selectedProject.number,
                    projectName: selectedProject.name
                });
            }
            getSubCodes(selectedProject.id);
            resetInvoiceGroupSubcodeSearchOptions();
        }
    }, [selectedProject]);

    useEffect(() => {
        if (!!selectedState) {
            // resetState({ value: selectedState, label: });
            console.log(selectedState);
        }
    }, [selectedState]);

    const onCreate = () => {
        // Put all initialization code here.
        setClientStateId(40);
        initializeClientSearchSettings();
        getSubCodeTypes();
        getSurveyTypes();
        getStates();
        getClientTypes();
        if (!projects) {
            setProjects([]);
        }
        getCurrentMileageRate();
        const saveCountiesButtonRef = document.getElementById('saveCountiesButton') as HTMLButtonElement;
        if (!!saveCountiesButtonRef) {
            setSaveCountiesRef(saveCountiesButtonRef);
        }
        const storedClientNumber = localStorage.getItem('backOfficeSelectedClientNumber');
        const storedClientName = localStorage.getItem('backOfficeSelectedClientName');
        if (!!storedClientNumber && !isNaN(Number(storedClientNumber)) && !!storedClientName) {
            setClientSearchTerm(storedClientNumber);
        }
        getUser();
    };

    const updateInvoiceGroupSections = async (payload: Array<InvoiceGroupSubcode>) => {
        let result = await post(`/v1.0/AccountsPayable/invoicegroup/sections/update`, payload);

        if (response.ok && result < 1) {
            console.log('Unable to update Invoice Group sections!');
        }
    };

    const getBillingInfo = async () => {
        const id = selectedSubcode?.id;
        if (id > 0) {
            let result = await get(`/v1.0/ClientProjectMaintenance/subcode/${id}/billing`);

            if (response.ok) {
                setAltOrSubcodeBillingInfo(result);
            } else {
                console.log('Unable to get subcode billing data!');
            }
        }
    };

    const getSubCodeTypes = async () => {
        let result = await get(`/v1.0/ClientProjectMaintenance/subcodes/types`);

        if (response.ok && !!result) {
            setSubcodeTypes(result.map((s: TsdiSubcodeType) => ({value: s.code, label: s.type})));
        } else {
            setSubcodeTypes([]);
            console.log('Unable to get subcode type data!');
        }
    };

    const getSurveyTypes = async () => {
        let result = await get(`/v1.0/ClientProjectMaintenance/subcodes/survey/types`);

        if (response.ok && !!result) {
            setSurveyTypes(result.map((s: TsdiSubcodeType) => ({value: s.code, label: s.type})));
        } else {
            setSurveyTypes([]);
            console.log('Unable to get subcode survey type data!');
        }
    };

    const getProjects = async () => {
        if (clients === undefined || clients?.length < 1) {
            return;
        }
        const clientIndex = clients?.findIndex((c) => c?.clientNumber === selectedClient?.clientNumber);
        if (clientIndex === -1) {
            return;
        }
        let result = await get(`/v1.0/ClientProjectMaintenance/projects/byclient/${clients[clientIndex].clientNumber}`);

        if (response.ok) {
            setProjects([]);
            setProjects(result);
        } else {
            setProjects([]);
            console.log('Unable to get client data!');
        }
    };

    const getCurrentMileageRate = async () => {
        let result = await get(`/v1.0/ClientProjectMaintenance/client/billing/mileagerate/current`);

        if (response.ok) {
            setCurrentMileageRate(result);
        } else {
            setCurrentMileageRate(.7);
            console.log('Unable to get mileage rate!');
        }
    };

    const createInvoiceGroup = async (payload: TsdiInvoiceGroup) => {
        let result = await post(`/v1.0/AccountsPayable/invoice/group/create`, payload);

        if (response.ok && result < 1) {
            console.log('Unable to create Invoice Group data!');
        }
    };

    const handleConfirmEditInvoiceGroup = (groupDefinition: TsdiInvoiceGroup) => {
        const invoiceGroupForUpdate = Array.isArray(creatingGroup) ? new TsdiInvoiceGroup() : _.cloneDeep(invoiceGroup);
        if (!invoiceGroupForUpdate) {
            return;
        }
        invoiceGroupForUpdate.description = groupDefinition.description;
        if (Array.isArray(creatingGroup)) {
            invoiceGroupForUpdate.accountCode = groupDefinition.accountCode;
            invoiceGroupForUpdate.projectId = selectedProject?.id;
            invoiceGroupForUpdate.creationDate = new Date();
            invoiceGroupForUpdate.closeDate = null;
            invoiceGroupForUpdate.closedBy = null;
            invoiceGroupForUpdate.closedByName = null;
            invoiceGroupForUpdate.groupTotal = null;
            // count
            invoiceGroupForUpdate.createdBy = tsdiNumber;
            invoiceGroupForUpdate.createdByName = tsdiName;
            invoiceGroupForUpdate.frequency = groupDefinition.frequency;
            invoiceGroupForUpdate.requestDate = groupDefinition.requestDate;
            invoiceGroupForUpdate.invoiceDate = groupDefinition.invoiceDate;
            // invoice group date
            // begin date
            invoiceGroupForUpdate.addSections = normalizeInvoiceGroupSubcodes(_.cloneDeep(creatingGroup));
            createInvoiceGroup(invoiceGroupForUpdate);
        } else {
            updateInvoiceGroup(invoiceGroupForUpdate);
        }

        setOpenInvoiceGrouping(new Object());
    };

    const updateInvoiceGroup = async (payload: TsdiInvoiceGroup) => {
        let result = await put(`/v1.0/AccountsPayable/invoice/group`, payload);

        if (response.ok && result < 1) {
            console.log('Unable to update Invoice Group data!');
        }
    };

    const normalizeInvoiceGroupSubcodes = (items: InvoiceGroupSubcode[]): InvoiceGroupSubcode[] => items.map(i => ( {
        ...i,
        sectionId: i.sectionId != null ? Number(i.sectionId) : undefined,
        sectionNumber: Number(i.sectionNumber),
        groupNumber: Number(i.groupNumber),
        prospectGroupNumber: Number(i.prospectGroupNumber),
        daysBilled: Number(i.daysBilled),
        unclosedInvoices: Number(i.unclosedInvoices),
        latestTimeEntry: new Date(i.latestTimeEntry)
    }));

    const onDestroy = () => {
        // Put all destruction code here.
    };

    const hideDialog = () => {
        setAddingSubcode(false);
        setFindingAltSubcode(false);
        setAddingAltSubcode(false);
        setShowBillingSettings(false);
        dispatch(actions.layout.hideDialog());
    };

    const hideAddAltSubcodeDialog = () => {
        setAddingAltSubcode(false);
        setFindingAltSubcode(false);
        setShowBillingSettings(false);
        dispatch(actions.layout.hideDialog());
        showAltSubcodeDialog();
    };

    const onCancel = () => {
        setAddingSubcode(false);
        dispatch(actions.layout.hideDialog());
    };

    const getClients = async () => {
        const queryString = clientSearchOptions?.toString();
        let result = await get(`/v1.0/AccountsPayable/clients${queryString}`);

        if (response.ok) {
            setClients([]);
            setClients(result.items);
            // Todo: get this from the DB and set it when the client is set from FindClientsDialog
        } else {
            setClients([]);
            console.log('Unable to get client data!');
        }
    };

    const initializeClientSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 100,
            idField: 'CL_NO',
            pageNumber: 1,
            columns: []
        };
        setClientSearchOptions(ODataOptions.from(tableConfig).addOrderBy('NAME1', ODataOrderByDirection.Ascending));
    };

    const prepFormData = () => {
        if (!!clients && clients?.length > 0) {
            console.log(clients[0]);
        }
    };

    const onStateSelected = (id: number) => {
        setSelectedState(id);
        getStatesCounties(id);
    };

    const getStatesCounties = async (id: number) => {
        const result = await get(`/v1.0/States/${id}/counties`);

        if (result) {
            setStateCounties(result);
        } else {
            console.log('Unable to retrieve the Counties for selected State.');
        }
    };

    const getStates = async () => {
        const result = await get(`/v1.0/states`);

        if (response.ok) {
            setStates(result);
        } else {
            console.log('Unable to retrieve States data.');
        }
    };

    const displayTitle = () => {
        const title = 'Subcode Maintenance';

        return title;
    };

    const displayHeading2 = () => {
        const title = 'Subcode Settings';

        return title;
    };

    const showAltSubcodeDialog = () => {
        showDialog(DialogList.ADD_ALT_SUBCODE);
    };

    const showBillingDialog = () => {
        showDialog(DialogList.ALT_OR_SUBCODE_BILLING_DIALOG);
    };

    const addProject = async (payload: ProspectDetails) => {
        let result = await post(`/v1.0/ClientProjectMaintenance/project`, payload);

        if (response.ok) {
            getProject(selectedClient?.clientNumber, result);
        }
    };

    const getProject = async (clientNumber: number, projectNumber: number) => {
        let result = await get(`/v1.0/ClientProjectMaintenance/project/${projectNumber}/client/${clientNumber}`);

        if (response.ok) {
            setSelectedProject(result);
        }
    };

    const populateSubcodeForm = (payload: TsdiSubcode) => {
        const formData: {
            calmsSection: number;
            subcodeClientName: string;
            subcodeType: string;
            taskSubcodeName: string;
            jeffersonianSubcodeName: string;
            subcodeClLmNumber: number;
            subcodeClLmName: string;
            subcodeAfeNumber: string;
            subcodePropId: number;
            subcodeClientAcct: string;
            subcodeAfeAmount: number;
            nonJeffersonianSubcodeAbstract: number;
            nonJeffersonianSubcodeBlock: string;
            nonJeffersonianSubcodeTownship: string;
            nonJeffersonianSubcodeSection: string;
            nonJeffersonianSubcodeFraction: string;
            nonJeffersonianSubcodeTsdNumber: number;
            nonJeffersonianSubcodeSurvey: string;
            easternStatesSubcodeTractDTU: string;
            easternStatesSubcodeTract: string;
            easternStatesSubcodeMunicipality: string;
            jeffersonianTownshipName: string,
            jeffersonianRangeName: string,
            jeffersonianSubcode: number,
            landmanSubcodeName: string,
            landmanSubcodeTSDNo: number,
            areaOfInterestSubcodeAoiNo: number,
            areaOfInterestSubcodeAoiName: string
            } = {
                calmsSection: payload?.number,
                subcodeClientName:  !!payload?.name ? payload.name : (!!payload?.clientSectionName ? payload?.clientSectionName : ''),
                jeffersonianSubcode: payload?.section,
                jeffersonianSubcodeName: payload?.name,
                jeffersonianTownshipName: payload?.township,
                jeffersonianRangeName: payload?.range,
                subcodeType:  payload?.type,
                taskSubcodeName: payload?.type === 'K' ? payload?.survey : '',
                subcodeClLmNumber: payload.clmNumber,
                subcodeClLmName: !!payload?.clientLandmanName ? payload.clientLandmanName : '',
                subcodeAfeNumber: payload.afeNumber,
                subcodePropId: !isNaN(Number(payload?.clientPropertyId)) ? Number(payload.clientPropertyId) : null,
                subcodeClientAcct: payload.clientAccountCode,
                subcodeAfeAmount: payload.afeAmount,
                nonJeffersonianSubcodeAbstract: !isNaN(Number( payload?.abstract)) ? Number( payload?.abstract) : null,
                nonJeffersonianSubcodeBlock: payload?.block,
                nonJeffersonianSubcodeSurvey: payload?.survey,
                nonJeffersonianSubcodeTownship: payload?.townshipName,
                nonJeffersonianSubcodeSection: payload?.sectionTexas,
                nonJeffersonianSubcodeFraction: payload?.fraction,
                nonJeffersonianSubcodeTsdNumber: (!isNaN(Number(payload?.tsdiNoAssigned)) &&
                    !!payload?.tsdiNoAssigned &&
                    (payload?.tsdiNoAssigned)?.toString() !== '') ? Number(payload?.tsdiNoAssigned) : null,
                easternStatesSubcodeTractDTU: !!payload?.survey ? payload?.survey : '' + payload?.distName,
                easternStatesSubcodeTract: payload?.name,
                easternStatesSubcodeMunicipality: payload?.townshipName,
                landmanSubcodeName: payload?.survey,
                landmanSubcodeTSDNo: !isNaN(Number( payload?.abstract)) ? Number( payload?.abstract) : null,
                areaOfInterestSubcodeAoiNo: !isNaN(Number( payload?.abstract)) ? Number( payload?.abstract) : null,
                areaOfInterestSubcodeAoiName: !!payload?.survey ? payload?.survey : '',
            };

        reset(formData);
        setSelectedSubcodeType(payload?.type);
        resetClientValues({
            clientNumber: selectedClient.clientNumber,
            clientName: selectedClient.clientName,
            projectNumber: selectedProject.number,
            projectName: selectedProject.name
        });
    };

    const getSubCodes = async (projectId: number) => {
        let result = await get(`/v1.0/ClientProjectMaintenance/client/${selectedClient?.clientNumber}/project/${projectId}/subcodes`);

        if (response.ok && !!result && result.length > 0) {
            setSubcodes(result);
        }
    };

    const getInvoiceGroupSubcodes = async () => {
        const queryString = invoiceGroupSubcodeSearchOptions?.toString();
        let result = await get(`/v1.0/AccountsPayable/invoice/group/subcodes${queryString}`);

        if (response.ok && result?.length > 0) {
            setIgSubcodes(result);
        } else {
            setIgSubcodes([]);
            console.log('Unable to get Invoice Group Data!!!');
        }
    };

    const getAltSubCodes = async (subcodeId: number) => {
        let result = await get(`/v1.0/ClientProjectMaintenance/subcode/${subcodeId}/altsubcodes`);

        if (response.ok && !!result && result.length > 0) {
            setSubcodes(result);
        }
    };

    const resetInvoiceGroupSubcodeSearchOptions = () => {
        let newInvoiceGroupSubcodeSearchOptions = _.cloneDeep(invoiceGroupSubcodeSearchOptions);
        newInvoiceGroupSubcodeSearchOptions.setIsNextpage(true);
        newInvoiceGroupSubcodeSearchOptions.clearFilters();
        newInvoiceGroupSubcodeSearchOptions.addPaging(1, 1000);
        newInvoiceGroupSubcodeSearchOptions.addFilter(new ODataFilter('igi.[cl_no]', ODataFilterOperators.Equals, '1387'));
        newInvoiceGroupSubcodeSearchOptions.addFilter(new ODataFilter('igi.[pr_no]', ODataFilterOperators.Equals, '2'));
        setInvoiceGroupSubcodeSearchOptions(newInvoiceGroupSubcodeSearchOptions);
    };

/*     const getSubCode = async (clientNumber: number, projectNumber: number) => {
        let result = await get(`/v1.0/ClientProjectMaintenance/project/${projectNumber}/client/${clientNumber}`);

        if (response.ok) {
            setSelectedSubcode(result);
        }
    }; */

    const updateSubcode = async (payload: TsdiSubcode) => {
        let result = await put(`/v1.0/ClientProjectMaintenance/subcode`, payload);

        if (response.ok && result === 1) {
            getSubCodes(selectedProject?.number);
        }
    };

    const updateAltSubcode = async (payload: TsdiAltSubcode) => {
        let result = await put(`/v1.0/ClientProjectMaintenance/subcode`, payload);

        if (response.ok && result === 1) {
            getAltSubCodes(selectedProject?.number);
        }
    };

    const getClientTypes = async () => {
        let result = await get(`/v1.0/ClientProjectMaintenance/clients/types`);
        setProjectTypes([]);
        if (response.ok) {
            setProjectTypes(result);
        }
    };

    const resetClientSearchOptions = () => {
        setFetchNextClientsPage(true);
        console.log(fetchNextClientsPage);
        let newClientSearchOptions = _.cloneDeep(clientSearchOptions);
        newClientSearchOptions.clearFilters();
        newClientSearchOptions.addPaging(1, 50);
        if (typeof clientSearchTerm === 'string') {
            const fieldValues = clientSearchTerm.split(',');
            if (fieldValues[0] !== undefined && !isNaN(Number(fieldValues[0]))) {
                newClientSearchOptions.addFilter(new ODataFilter('CL_NO', ODataFilterOperators.Equals, !!clientSearchTerm ? fieldValues[0] : ''));
            }
            if (fieldValues[1] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('NAME1', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[1] : ''));
            }
            if (fieldValues[2] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('NAME2', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[2] : ''));
            }
            if (fieldValues[3] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('CITY', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[3] : ''));
            }
            if (fieldValues[4] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('STATE', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[4] : ''));
            }
            if (fieldValues[5] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('ZIP', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[5] : ''));
            }
            if (fieldValues[6] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('PHONE', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[6] : ''));
            }
        }
        setClientSearchOptions(newClientSearchOptions);
    };

    const resetProjectSearchOptions = () => {
        setFetchNextProjectsPage(true);
        console.log(fetchNextProjectsPage);
        let newProjectSearchOptions = _.cloneDeep(projectSearchOptions);
        newProjectSearchOptions.clearFilters();
        newProjectSearchOptions.addPaging(1, 50);
        if (typeof projectSearchTerm === 'string') {
            const fieldValues = projectSearchTerm.split(',');
            if (fieldValues[0] !== undefined && !isNaN(Number(fieldValues[0]))) {
                newProjectSearchOptions.addFilter(new ODataFilter('[CL_NO]', ODataFilterOperators.Equals, !!projectSearchTerm ? fieldValues[0] : ''));
            }
            if (fieldValues[1] !== undefined && !isNaN(Number(fieldValues[1]))) {
                newProjectSearchOptions.addFilter(new ODataFilter('[PR_NO]', ODataFilterOperators.Equals, !!projectSearchTerm ? fieldValues[1] : ''));
            }
            if (fieldValues[2] !== undefined && !isNaN(Number(fieldValues[2]))) {
                newProjectSearchOptions.addFilter(new ODataFilter('[PR_NAME]', ODataFilterOperators.Contains, !!projectSearchTerm ? fieldValues[2] : ''));
            }
            if (fieldValues[3] !== undefined && !isNaN(Number(fieldValues[3]))) {
                newProjectSearchOptions.addFilter(new ODataFilter('[TSD_MGR]', ODataFilterOperators.Contains, !!projectSearchTerm ? fieldValues[3] : ''));
            }
            if (fieldValues[4] !== undefined && !isNaN(Number(fieldValues[4]))) {
                newProjectSearchOptions.addFilter(new ODataFilter('[PROJECT_COORDINATOR]', ODataFilterOperators.Contains, !!projectSearchTerm ? fieldValues[4] : ''));
            }
            if (fieldValues[5] !== undefined && !isNaN(Number(fieldValues[5]))) {
                newProjectSearchOptions.addFilter(new ODataFilter('[OFFICE]', ODataFilterOperators.Contains, !!projectSearchTerm ? fieldValues[5] : ''));
            }
        }
        setProjectSearchOptions(newProjectSearchOptions);
    };

    const openWarningDialog = () => {
        showDialog(DialogList.WARNING);
    };

    const onHandleClosureRequest = (igNumber: number, isCancellation: boolean, isClose: boolean) => {
        setClosureRequest({ groupNumber: igNumber, cancelRequest: isCancellation, close: isClose });
        openWarningDialog();
    };

    const onHandleConfirmClosureRequest = () => {
        if (closureRequest?.groupNumber && closureRequest.cancelRequest !== undefined && closureRequest.cancelRequest !== null) {
            updateInvoiceGroupRequest();
        }
        hideDialog();
    };

    const displayTaskSectionOptions = () => {
        return (
            <>
                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                    <RHFInputBox
                        label={'Task Name'}
                        labelOnLeft={true}
                        name={'taskSubcodeName'}
                        style={{ width: '100%' }}
                        bodyStyle={{width: '100%' }}
                        register={register}
                    />
                </div>
            </>
        );
    };

    const displayLandmanSectionOptions = () => {
        return (
            <>
                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                    <RHFInputBox
                        label={'TSD #'}
                        labelOnLeft={true}
                        name={'landmanSubcodeTSDNo'}
                        style={{ width: '100%' }}
                        bodyStyle={{width: '30%' }}
                        register={register}
                    />
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Find Landman"
                        iconImage={`findLandman.png`}
                        iconHoverColor="blue"
                        iconStyle={{width: '22px', height: '22px', verticalAlign: 'center'}}
                        onClick={() => findPerson()}
                    />
                </div>
                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                    <RHFInputBox
                        label={'Name'}
                        labelOnLeft={true}
                        name={'landmanSubcodeName'}
                        style={{ width: '100%' }}
                        bodyStyle={{width: '100%' }}
                        register={register}
                    />
                </div>
            </>
        );
    };

    const displayEasterStatesSectionOptions = () => {
        return (
            <>
                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                    <RHFInputBox
                        label={'District/Township/Unit Name'}
                        labelOnLeft={true}
                        name={'easternStatesSubcodeTractDTU'}
                        style={{ width: '100%' }}
                        bodyStyle={{width: '100%' }}
                        register={register}
                    />
                </div>
                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                    <RHFInputBox
                        label={'Tract'}
                        labelOnLeft={true}
                        name={'easternStatesSubcodeTract'}
                        style={{ width: '100%' }}
                        bodyStyle={{width: '100%' }}
                        register={register}
                    />
                </div>
                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                    <RHFInputBox
                        label={'Municipality'}
                        labelOnLeft={true}
                        name={'easternStatesSubcodeMunicipality'}
                        style={{ width: '100%' }}
                        bodyStyle={{width: '100%' }}
                        register={register}
                    />
                </div>
                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                    <RHFInputBox
                        label={'Assigned to:'}
                        labelOnLeft={true}
                        name={'easternStatesSubCodeAssigned'}
                        style={{ width: '30%' }}
                        bodyStyle={{width: '100%' }}
                        register={register}
                    />
                    <RHFInputBox
                        label={'TSD #'}
                        labelOnLeft={true}
                        name={'easternStatesSubcodeTsdNo'}
                        style={{ width: '30%' }}
                        bodyStyle={{width: '100%' }}
                        register={register}
                    />
                    <RHFInputBox
                        label={'Name'}
                        labelOnLeft={true}
                        name={'easternStatesSubcodeTsdName'}
                        style={{ width: '100%' }}
                        bodyStyle={{width: '100%' }}
                        register={register}
                    />
                </div>
            </>
        );
    };

    const displayAreaOfInterestSectionOptions = () => {
        return (
            <>
            <div style={{display: 'flex', alignItems: 'flex-start'}}>
                <RHFInputBox
                    label={'AOI #'}
                    labelOnLeft={true}
                    name={'areaOfInterestSubcodeAoiNo'}
                    style={{ width: '30%' }}
                    bodyStyle={{width: '40%' }}
                    register={register}
                />
            </div>
            <div style={{display: 'flex', alignItems: 'flex-start'}}>
                <RHFInputBox
                    label={'AOI Name'}
                    labelOnLeft={true}
                    name={'areaOfInterestSubcodeAoiName'}
                    style={{ width: '30%' }}
                    bodyStyle={{width: '40%' }}
                    register={register}
                />
            </div>
            <div style={{display: 'flex', alignItems: 'flex-start'}}>
                <RHFInputBox
                    label={'AOI State'}
                    labelOnLeft={true}
                    name={'areaOfInterestSubcodeAoiState'}
                    style={{ width: '30%' }}
                    bodyStyle={{width: '40%' }}
                    register={register}
                />
            </div>
            <div style={{display: 'flex', alignItems: 'flex-start'}}>
                <RHFInputBox
                    label={'Client Code'}
                    labelOnLeft={true}
                    name={'areaOfInterestSubcodeClientCode'}
                    style={{ width: '30%' }}
                    bodyStyle={{width: '40%' }}
                    register={register}
                />
            </div>
            </>
        );
    };

    const displayNonJeffersonianSectionOptions = () => {
        return (
            <>
            <div style={{display: 'flex', alignItems: 'flex-start'}}>
                <RHFInputBox
                    label={'Abstract'}
                    labelOnLeft={true}
                    type={'number'}
                    name={'nonJeffersonianSubcodeAbstract'}
                    style={{ width: '30%' }}
                    bodyStyle={{width: '40%' }}
                    register={register}
                />
                <RHFSelect
                    name={`nonJeffersonianSurveyTypes`}
                    options={!!surveyTypes ? surveyTypes : [
                        {value: 'S', label: 'Survey' },
                        {value: 'T', label: 'Township' },
                        {value: 'G', label: 'Grant' },
                        {value: 'P', label: 'Porcione' },
                        {value: 'B', label: 'Subdivision' },
                        {value: 'E', label: 'League' },
                        {value: 'A', label: 'Labor' }
                    ]}
                    defaultVal={!!selectedSubcode?.surveyType ? selectedSubcode.surveyType : 'S'}
                    register={register}
                    style={{ width: '55%' }}
                    bodyStyle={{width: '40%' }}
                />
            </div>
            <div style={{display: 'flex', alignItems: 'flex-start'}}>
                <RHFInputBox
                    label={'Survey'}
                    labelOnLeft={true}
                    name={'nonJeffersonianSubcodeSurvey'}
                    style={{ width: '100%' }}
                    bodyStyle={{width: '100%' }}
                    register={register}
                />
            </div>
            <div style={{display: 'flex', alignItems: 'flex-start'}}>
                <RHFInputBox
                    label={'Block'}
                    labelOnLeft={true}
                    name={'nonJeffersonianSubcodeBlock'}
                    style={{ width: '100%' }}
                    bodyStyle={{width: '30%' }}
                    register={register}
                    rules={{ maxLength: { value: 5, message: 'Block cannot exceed 5 characters.' } }}
                />
                <RHFInputBox
                    label={'Township'}
                    labelOnLeft={true}
                    name={'nonJeffersonianSubcodeTownship'}
                    style={{ width: '100%' }}
                    bodyStyle={{width: '30%' }}
                    register={register}
                    type={'text'}
                    rules={{ maxLength: { value: 5, message: 'Township cannot exceed 5 characters.' } }}
                />
                <RHFInputBox
                    label={'Section'}
                    labelOnLeft={true}
                    name={'nonJeffersonianSubcodeSection'}
                    style={{ width: '100%' }}
                    bodyStyle={{width: '30%' }}
                    register={register}
                    type={'text'}                    
                    rules={{ maxLength: { value: 7, message: 'Section cannot exceed 7 characters.' } }}
                />
                <RHFInputBox
                    label={'Fraction'}
                    labelOnLeft={true}
                    name={'nonJeffersonianSubcodeFraction'}
                    style={{ width: '100%' }}
                    bodyStyle={{width: '30%' }}
                    register={register}
                />
            </div>
            <div style={{display: 'flex', alignItems: 'flex-start'}}>
                <div style={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-start'}}>
                    <label>Assigned LM:</label>
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Find Landman"
                        iconImage={`findLandman.png`}
                        iconHoverColor="blue"
                        iconStyle={{width: '22px', height: '22px', verticalAlign: 'center'}}
                        onClick={() => findPerson()}
                    />
                </div>
                <RHFInputBox
                    label={'TSD #'}
                    labelOnLeft={true}
                    name={'nonJeffersonianSubcodeTsdNumber'}
                    style={{ width: '100%' }}
                    bodyStyle={{width: '30%' }}
                    register={register}
                    type={'number'}
                />
                <RHFInputBox
                    label={'Name'}
                    labelOnLeft={true}
                    name={'nonJeffersonianSubcodeName'}
                    style={{ width: '100%' }}
                    bodyStyle={{width: '60%' }}
                    register={register}
                />
            </div>
            <div>
                {errors.nonJeffersonianSubcodeTownship && <p style={{color: 'red'}}>{errors.nonJeffersonianSubcodeTownship.message}</p>}
                {errors.nonJeffersonianSubcodeSection && <p style={{color: 'red'}}>{errors.nonJeffersonianSubcodeSection.message}</p>}
            </div>
            </>
        );
    };

    const displayJeffersonianSectionOptions = () => {
        return (
            <>
                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                    <RHFInputBox
                        label={'Subcode'}
                        labelOnLeft={true}
                        name={'jeffersonianSubcode'}
                        style={{ width: '30%' }}
                        bodyStyle={{width: '100%' }}
                        register={register}
                    />
                </div>
                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                    <RHFInputBox
                        label={'Township'}
                        labelOnLeft={true}
                        name={'jeffersonianTownshipName'}
                        style={{ width: '100%' }}
                        bodyStyle={{width: '100%' }}
                        register={register}
                    />
                    <RHFSelect
                        name={`jeffersonianTownshipQuarter`}
                        options={!!subcodeTypes ? subcodeTypes : [
                            {value: '1', label: '1/4' },
                            {value: '2', label: '1/2' },
                            {value: '3', label: '3/4' }
                        ]}
                        register={register}
                        style={{ width: '55%' }}
                        bodyStyle={{width: '40%' }}
                    />
                    <RHFSelect
                        name={`jeffersonianTownshipDirection`}
                        options={!!subcodeTypes ? subcodeTypes : [
                            {value: '1', label: 'North' },
                            {value: '2', label: 'South' },
                            {value: '3', label: 'East' },
                            {value: '4', label: 'West' }
                        ]}
                        register={register}
                        style={{ width: '55%' }}
                        bodyStyle={{width: '40%' }}
                    />
                </div>
                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                    <RHFInputBox
                        label={'Range'}
                        labelOnLeft={true}
                        name={'jeffersonianRangeName'}
                        style={{ width: '100%' }}
                        bodyStyle={{width: '100%' }}
                        register={register}
                    />
                    <RHFSelect
                        name={`jeffersonianRangeQuarter`}
                        options={!!subcodeTypes ? subcodeTypes : [
                            {value: '1', label: '1/4' },
                            {value: '2', label: '1/2' },
                            {value: '3', label: '3/4' }
                        ]}
                        register={register}
                        style={{ width: '55%' }}
                        bodyStyle={{width: '40%' }}
                    />
                    <RHFSelect
                        name={`jeffersonianRangeDirection`}
                        options={!!subcodeTypes ? subcodeTypes : [
                            {value: '1', label: 'North' },
                            {value: '2', label: 'South' },
                            {value: '3', label: 'East' },
                            {value: '4', label: 'West' }
                        ]}
                        register={register}
                        style={{ width: '55%' }}
                        bodyStyle={{width: '40%' }}
                    />
                </div>
                <div style={{display: 'flex', alignItems: 'flex-start'}}>
                    <RHFInputBox
                        label={'Assigned to:'}
                        labelOnLeft={true}
                        name={'jeffersonianSubCodeAssigned'}
                        style={{ width: '30%' }}
                        bodyStyle={{width: '100%' }}
                        register={register}
                    />
                    <RHFInputBox
                        label={'TSD #'}
                        labelOnLeft={true}
                        name={'jeffersonianSubcodeTsdNo'}
                        style={{ width: '30%' }}
                        bodyStyle={{width: '100%' }}
                        register={register}
                    />
                    <RHFInputBox
                        label={'Name'}
                        labelOnLeft={true}
                        name={'jeffersonianSubcodeName'}
                        style={{ width: '100%' }}
                        bodyStyle={{width: '100%' }}
                        register={register}
                    />
                </div>
            </>
        );
    };

    const displaySubcodeSettingButtons = () => {
        return (
            <>
                <RHFInputBox
                    label={'CALMs Section #'}
                    labelOnLeft={true}
                    name={'calmsSection'}
                    style={{ width: '30%' }}
                    bodyStyle={{width: '20%' }}
                    register={register}
                    type={'number'}
                />
                <RHFSelect
                    label={`Subcode Type`}
                    name={`subcodeType`}
                    defaultVal={!!selectedSubcode?.type ? selectedSubcode.type : 'S'}
                    options={!!subcodeTypes ? subcodeTypes : [{value: 'S', label: 'Jeffersonian' }]}
                    register={register}
                    style={{ width: '55%' }}
                    bodyStyle={{width: '40%' }}
                    onChange={(v) => setSelectedSubcodeType(v.currentTarget.value)}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Find Subcode"
                    reactIcon={BsSearch}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => findSubcode(false)}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to First Subcode"
                    reactIcon={BiArrowToLeft}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => moveToFirstSubcode()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Previous Subcode"
                    reactIcon={BiLeftArrowAlt}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => moveToPreviousSubcode()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Add New Subcode"
                    reactIcon={BiAddToQueue}
                    iconHoverColor="blue"
                    iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                    onClick={() => findSubcode(true)}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Save Subcode Changes"
                    reactIcon={FaRegSave}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    type={'submit'}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Next Subcode"
                    reactIcon={BiRightArrowAlt}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => moveToNextSubcode()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Last Subcode"
                    reactIcon={BiArrowToRight}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => moveToLastSubcode()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Excel Report"
                    reactIcon={FaFileExcel}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => alert('Implement Excel Report')}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Billing"
                    reactIcon={FaFileInvoiceDollar}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => showBillingDialog()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Land System Export"
                    reactIcon={FaFileExport}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => alert('Calms section export not implemented.')}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Land System Import"
                    reactIcon={FaFileImport}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => alert('Calms section import not implemented.')}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="AP/PCM History"
                    reactIcon={AiOutlineHistory}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => alert('Subcode Ap/PCM history not implemented.')}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Alternate Subcode"
                    reactIcon={MdSubdirectoryArrowRight}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => showAltSubcodeDialog()}
                />
            </>
        );
    };

    const displaySubcodeSettings = () => {
        return (
            <>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <RHFInputBox
                    label={'IG #'}
                    labelOnLeft={true}
                    name={'igNumber'}
                    style={{ width: '30%' }}
                    bodyStyle={{width: '100%' }}
                    register={register}
                />
                <RHFInputBox
                    label={'Performance PC/PCM'}
                    labelOnLeft={true}
                    name={'subcodePcApmNumber'}
                    style={{ width: '30%' }}
                    bodyStyle={{width: '100%' }}
                    register={register}
                />
                <RHFInputBox
                    label={''}
                    labelOnLeft={true}
                    name={'subcodePcApmName'}
                    style={{ width: '100%' }}
                    bodyStyle={{width: '100%' }}
                    register={register}
                />
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                    <Button
                        className="blue-hover-button"
                        type="button"
                        style={{ width: '24%', marginRight: '1rem' }}
                        text={'Invoice Groups'}
                        onClick={() => showInvoiceGroupingDialog()}
                    />
                </div>
            </>
        );
    };

    const AddProjectAndHideDialog = (payload: ProspectDetails) => {
        addProject(payload);
        hideDialog();
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };

    const showAddSubcodeDialog = () => {
        dispatch(actions.layout.showDialog(DialogList.FIND_ALTSUBCODE));
    };

    const findClient = () => {
        showDialog(DialogList.FIND_CLIENT);
    };

    const showInvoiceGroupingDialog = () => {
        showDialog(DialogList.INVOICE_GROUPING);
    };

    const findSubcode = (addNewSubcode: boolean) => {
        if (!!addNewSubcode) {
            setAddingSubcode(true);
        } else {
            setAddingSubcode(false);
            showDialog(DialogList.FIND_SUBCODE);
        }
    };

    const onSubmit = () => {
        if (isDirty) {
            onSaveChanges();
        }
    };

    const onSubmitCounties = (formData: { addCounties: Array<County> }) => {
        setCountiesForUpdate(!!formData.addCounties ? formData.addCounties : [{ id: null, name: null, stateId: null }]);
    };

    const findPerson = () => {
        alert('Implement find landman');
    };

    const reportOptions = () => {
        alert('Implement report options');
    };

    const moveToFirstSubcode = () => {
        if (!!subcodes && subcodes?.length > 1) {
            setSelectedSubcode(subcodes[0]);
        }
    };

    const moveToPreviousSubcode = () => {
        const selectedIndex = subcodes.findIndex((s) => s.id === selectedSubcode.id);
        if (!!subcodes && selectedIndex > 0 && selectedIndex < subcodes.length) {
            setSelectedSubcode(subcodes[selectedIndex - 1]);
        } else {
            alert('No more subcodes.');
        }
    };

    const moveToNextSubcode = () => {
        if (!!subcodes) {
            const selectedIndex = subcodes.findIndex((s) => s.id === selectedSubcode.id);
            if (!!subcodes && selectedIndex !== -1 && selectedIndex < subcodes.length - 1) {
                setSelectedSubcode(subcodes[selectedIndex + 1]);
            } else {
                alert('No more subcodes.');
            }
        } else {
            alert('No subcodes.');
        }
    };

    const moveToLastSubcode = () => {
        if (!!subcodes && subcodes?.length > 1) {
            setSelectedSubcode(subcodes[subcodes.length - 1]);
        }
    };

    const getStateNameFromId = (id: number) => {
        return (states.items.find(s => s.id === id))?.name;
    };

    const generateSubcodeUpdatePayload = () => {
        const tsdiCounties = countiesForUpdate.map(c => {
            return ({ county: c.name, state: getStateNameFromId(selectedState) });
        });
        const subcodeFormData = getValues();
        const payload: Partial<TsdiSubcode> = {
            id: selectedSubcode?.id,
            projectId: selectedProject?.id,
            name: subcodeFormData.subcodeName,
            number: !isNaN(Number(subcodeFormData.calmsSection)) ? Number(subcodeFormData.calmsSection) : null,
            clmNumber: !isNaN(Number(subcodeFormData.subcodeClLmNumber)) ? Number(subcodeFormData.subcodeClLmNumber) : null,
            clientAccountCode: subcodeFormData.subcodeClientAcct,
            crewChief: subcodeFormData.crewChief,
            section: !isNaN(Number(subcodeFormData?.jeffersonianSubcode)) &&
                !!subcodeFormData?.jeffersonianSubcode &&
                subcodeFormData?.jeffersonianSubcode.toString() !== '' ? Number(subcodeFormData.jeffersonianSubcode) : null,
            township: (selectedSubcodeType === 'T' &&
                !! subcodeFormData?.nonJeffersonianSubcodeTownship) ?  subcodeFormData?.nonJeffersonianSubcodeTownship : subcodeFormData?.township,
            range: subcodeFormData.range,
            type: subcodeFormData.subcodeType,
            survey: selectedSubcodeType === 'K' ?
                subcodeFormData.taskSubcodeName : (selectedSubcodeType === 'T' ?
                    (!!subcodeFormData?.nonJeffersonianSubcodeSurvey ?
                        subcodeFormData?.nonJeffersonianSubcodeSurvey : '') : ''),
            surveyType: subcodeFormData?.nonJeffersonianSurveyTypes,
            abstract: !isNaN(Number(subcodeFormData?.nonJeffersonianSubcodeAbstract)) &&
                !!subcodeFormData.nonJeffersonianSubcodeAbstract &&
                subcodeFormData.nonJeffersonianSubcodeAbstract.toString() !== ''  ? Number(subcodeFormData.nonJeffersonianSubcodeAbstract) : null,
            block: subcodeFormData?.nonJeffersonianSubcodeBlock,
            fraction: subcodeFormData?.nonJeffersonianSubcodeFraction,
            sectionTexas: subcodeFormData.nonJeffersonianSubcodeSection,
            distName: subcodeFormData.distName,
            townshipName: subcodeFormData.townshipName,
            meridian: subcodeFormData.meridian,
            tsdiNoAssigned: !isNaN(Number(subcodeFormData?.nonJeffersonianSubcodeTsdNumber)) ? Number(subcodeFormData.nonJeffersonianSubcodeTsdNumber) : null,
            afeNumber: subcodeFormData.subcodeAfeNumber,
            clientPropertyId: !isNaN(Number(subcodeFormData.subcodePropId)) ? Number(subcodeFormData.subcodePropId) : null,
            clientSectionName: subcodeFormData.clientSectionName,
            budgetAmount: null,
            afeAmount: !isNaN(Number(subcodeFormData.subcodeAfeAmount)) ? Number(subcodeFormData.subcodeAfeAmount) : null,
            counties: tsdiCounties
        };

        return payload as TsdiSubcode;
    };

    const onSaveChanges = () => {
        saveCountiesRef.click();
    };

    const runQuery = () => {
        alert('Run query for client and project');
    };

    const moveToFirstRecord = () => {
        alert('Implement move to 1st client/project record');
    };

    const moveToLastRecord = () => {
        alert('Implement move to last client/project record');
    };

    const moveToPreviousRecord = () => {
        alert('Implement move to 1st client/project record');
    };

    const moveToNextRecord = () => {
        alert('Implement move to 1st client/project record');
    };

    const getDayRate = () => {
        let dayRate = 250.00;
        if (!!addingSubcode) {
            if (!!selectedClient && !!selectedClient?.dayRate) {
                dayRate = selectedClient.dayRate;
            }
        }
        return dayRate;
    };

    const getUser = async () => {
        const result = await get(`v1.0/users/${appContext.currentUser.userId}`);

        if (response.ok) {
            setTsdiNumber(result.lmsNumber);
            setTsdiName(result.firstName + ' ' + result.lastName);
        }
    };

    const updateInvoiceGroupRequest = async () => {
        if (closureRequest && closureRequest.groupNumber) {
            let payload: Partial<TsdiInvoiceGroupRequest> = {};
            if (closureRequest?.cancelRequest) {
                payload = {
                    closeRequestDate: null,
                    closureRequest: 1
                };
            } else if (!closureRequest?.close) {
                payload.closeRequestDate = new Date();
                payload.closureRequest = 1;
            } else {
                payload.closeDate = new Date();
                payload.closedByNumber = tsdiNumber;
                payload.closedByName = tsdiName;
                payload.closureRequest = 1;
            }
            payload.groupIrNumber = closureRequest?.groupNumber;
            let result = await put(`/v1.0/AccountsPayable/invoice/group/request`, payload);

            if (response.ok && result < 1) {
                console.log('Unable to update Invoice GroupRequest data!');
            }

            setFinalizeClosureRequest(new Object());
        }
    };

    const getWarningDialogMessage = () => {
        if (closureRequest?.cancelRequest) {
            return 'Click OK to revoke Closure Request, Cancel to abort.';
        } else if (closureRequest?.close) {
            return 'Click OK to Close Invoice Group' + ' ' + closureRequest?.groupNumber + '.';
        } else {
            return 'Click OK to confirm Closure Request, Cancel to abort.';
        }
    };

    const getWarningDialogLabel = () => {
        const intro = closureRequest?.close ? 'This will close ' : (closureRequest?.cancelRequest ?
            'This will Cancel the pending closure request for ' : 'You are requesting to close' );
        const suffix =  'Invoice Group ' + closureRequest?.groupNumber + '.';
        return intro + suffix;
    };

    const displaySubCodeSettings2 = () => {
        return (
            <>
                    <div className="form-row" style={{ marginBottom: '0' }}>
                        <RHFInputBox
                            label={'CL LM'}
                            labelOnLeft={true}
                            name={'subcodeClLmNumber'}
                            style={{ width: '100%' }}
                            bodyStyle={{width: '30%' }}
                            register={register}
                        />
                        <RHFInputBox
                            name={'subcodeClLmName'}
                            style={{ width: '100%' }}
                            bodyStyle={{width: '60%' }}
                            register={register}
                        />
                    </div>
                    <div style={{whiteSpace: 'nowrap', display: 'flex', justifyContent: 'left'}}>
                        <RHFInputBox
                            label={'AFE #'}
                            labelOnLeft={true}
                            name={'subcodeAfeNumber'}
                            style={{ width: '100%' }}
                            bodyStyle={{width: '30%' }}
                            register={register}
                        />
                        <RHFInputBox
                            label={'AFE Amount'}
                            labelOnLeft={true}
                            name={'subcodeAfeAmount'}
                            style={{ width: '100%' }}
                            bodyStyle={{width: '40%' }}
                            register={register}
                        />
                    </div>
                    <RHFInputBox
                        label={'Client Section Name:'}
                        labelOnLeft={true}
                        name={'subcodeClientName'}
                        style={{ width: '100%' }}
                        bodyStyle={{width: '100%' }}
                        register={register}
                    />
                    <div style={{whiteSpace: 'nowrap', display: 'flex', justifyContent: 'left'}}>
                        <RHFInputBox
                            label={'Client Account'}
                            labelOnLeft={true}
                            name={'subcodeClientAcct'}
                            style={{ width: '100%' }}
                            bodyStyle={{width: '60%' }}
                            register={register}
                            defaultVal={
                                (!!selectedClient?.clientNumber ? selectedClient?.clientNumber : '')
                                + (!!selectedClient?.clientNumber ? '.' : '')
                                + (!!selectedProject?.number ? selectedProject.number : '')
                                + (!!selectedProject?.number ? '.' : '') + (!!selectedSubcode?.number ? selectedSubcode?.number : '')
                            }
                        />
                        <RHFInputBox
                            label={'Prop ID'}
                            labelOnLeft={true}
                            name={'subcodePropId'}
                            style={{ width: '100%' }}
                            bodyStyle={{width: '30%' }}
                            register={register}
                        />
                    </div>
            </>);
    };

    const displayCounties = () => {
        return (
            <>
                <table>
                    <thead>
                        <tr>
                            <th>
                                State
                            </th>
                            <th>
                                County
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                    {selectedProject?.counties?.map((c, index) =>
                        <tr key={index}>
                            <td>
                                {c?.state}
                            </td>
                            <td>
                                {c?.county}
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </>);
    };

    return (
        <>
        <div>
        <CPNavBar/>
        <ClientProjectSearch
            setSelectedClient={setSelectedClient}
            setSelectedProject={setSelectedProject}
            clients={clients}
            projects={true}
            runQuery={runQuery}
            size={6}
        />
           <div style={{display: 'flex', width: '100vw', justifyContent: 'center'}}>
                <form id={`SubcodeMaintenanceForm`} onSubmit={handleSubcodeSubmit(onSubmit)}>
                <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayTitle()}>
                                    <div style={{ border: 'solid rgb(99, 147, 193) 1px', padding: '.5rem' }}>
                                        <div className="form-row" style={{ marginBottom: '0' }}>
                                            <RHFInputBox
                                                name={'clientNumber'}
                                                style={{width: '100%'}}
                                                bodyStyle={{width: '15%'}}
                                                register={registerClientValues}
                                                readOnly={true}
                                            />
                                            <RHFInputBox
                                                name={'clientName'}
                                                style={{width: '100%'}}
                                                register={registerClientValues}
                                                readOnly={true}
                                            />
                                            <RHFInputBox
                                                name={'projectNumber'}
                                                style={{width: '100%'}}
                                                bodyStyle={{width: '15%'}}
                                                register={registerClientValues}
                                                readOnly={true}
                                            />
                                            <RHFInputBox
                                                name={'projectName'}
                                                style={{width: '100%'}}
                                                register={registerClientValues}
                                                readOnly={true}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Find Client"
                                                reactIcon={BsSearch}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => findClient()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Find Landman"
                                                iconImage={`findLandman.png`}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '22px', height: '22px', verticalAlign: 'center'}}
                                                onClick={() => findPerson()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Reports"
                                                reactIcon={VscGraph}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center', marginTop: '.4rem'}}
                                                onClick={() => reportOptions()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to First Record"
                                                reactIcon={BiArrowToLeft}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => moveToFirstRecord}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Previous Record"
                                                reactIcon={BiLeftArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToPreviousRecord}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Next Record"
                                                reactIcon={BiRightArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToNextRecord}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Last Record"
                                                reactIcon={BiArrowToRight}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToLastRecord}
                                            />
                                        </div>
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayHeading2()}>
                                    <div style={{marginBottom: '1rem', display: 'flex', width: '100%', justifyContent: 'center'}}>
                                        {displaySubcodeSettingButtons()}
                                    </div>
                                    <div style={{width: '100%', display: 'flex', justifyContent: 'left'}}>
                                        <div style={{border: 'solid rgb(99, 147, 193) 1px', width: '60%', height: '200px'}}>
                                            {selectedSubcodeType === 'S' && displayJeffersonianSectionOptions()}
                                            {selectedSubcodeType === 'T' && displayNonJeffersonianSectionOptions()}
                                            {selectedSubcodeType === 'G' && displayAreaOfInterestSectionOptions()}
                                            {selectedSubcodeType === 'D' && displayEasterStatesSectionOptions()}
                                            {selectedSubcodeType === 'L' && displayLandmanSectionOptions()}
                                            {selectedSubcodeType === 'K' && displayTaskSectionOptions()}
                                        </div>
                                        <div style={{border: 'solid rgb(99, 147, 193) 1px', width: '40%', height: '200px'}}>
                                            {displaySubCodeSettings2()}
                                        </div>
                                    </div>
                                    <div style={{ border: 'solid rgb(99, 147, 193) 1px', paddingBottom: '.5rem' }}>
                                        {displaySubcodeSettings()}
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={'Counties'}>
                                    <div style={{display: 'flex', width: '100%', justifyContent: 'left'}}>
                                    <Form
                                        onSubmit={onSubmitCounties}
                                        mutators={{ ...arrayMutators }}
                                        render={({ handleSubmit, form }) => {
                                            return (
                                                <form onSubmit={handleSubmit}>
                                                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                        <div style={{ display: 'flex', gap: '2rem', width: '98%' }}>
                                                            {selectStates && <RHFSelect
                                                                label="State"
                                                                name="stateId"
                                                                options={selectStates}
                                                                defaultVal={'Select State'}
                                                                onChange={(e) => onStateSelected(Number(e.currentTarget.value))}
                                                                style={{ width: '100%' }}
                                                                register={registerState}
                                                                bodyStyle={{ width: '30%' }}
                                                            />}
                                                            <TagContainer
                                                                label="Subcode Counties"
                                                                isTagCreatable={false}
                                                                fieldArrayName="counties"
                                                                fieldAddArrayName="addCounties"
                                                                fieldDeleteArrayName="deleteCounties"
                                                                initialValueName="county"
                                                                form={form}
                                                                selectTags={selectStateCounties ? selectStateCounties : new Array<SelectItem>()}
                                                            />
                                                            <div style={{display: 'flex', justifyContent: 'center', width: '20vw' }}>
                                                                {displayCounties()}
                                                            </div>
                                                            <Button
                                                                style={{display: 'none'}}
                                                                id={'saveCountiesButton'}
                                                                type={'submit'}
                                                                text={'Save Counties'}
                                                            />
                                                        </div>
                                                    </div>
                                                </form>
                                            );
                                        }}
                                    />
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                </form>
            </div>
        </div>
            <AltAndSubcodeBillingDialog
                hideDialog={!!showBillingSettings ? hideAddAltSubcodeDialog : hideDialog}
                showDialog={showDialog}
                dialogName={DialogList.ALT_OR_SUBCODE_BILLING_DIALOG}
                billingInfo={!!altOrSubcodeBillingInfo ? altOrSubcodeBillingInfo : {
                    id: selectedSubcode?.id,
                    invoiceFormat: 'A',
                    backupOfficeRate: 250.00,
                    chargeOfficeBackup: false,
                    chargeOfficeExpenses: true,
                    breakdownOfficeExpenses: false
                }}
                altSubCode={showBillingSettings}
                refreshSubcodeBillingInfo={getBillingInfo}
            />
            {(addingAltSubcode || findingAltSubcode) && <AddAltSubcodeDialog
                dialogName={DialogList.FIND_ALTSUBCODE}
                hideDialog={hideAddAltSubcodeDialog}
                subcode={selectedSubcode}
                addNewSubcode={addingAltSubcode}
                clientNumber={selectedClient?.clientNumber}
                projectNumber={selectedProject?.number}
                updateAltSubcode={updateAltSubcode}
            />}
            <AltSubCodeDialog
                dialogName={DialogList.ADD_ALT_SUBCODE}
                project={selectedProject}
                client={selectedClient}
                hideDialog={hideDialog}
                showDialog={showDialog}
                subCode={selectedSubcode}
                showAddSubcodeDialog={showAddSubcodeDialog}
                setAddingAltSubcode={setAddingAltSubcode}
                setFindingAltSubcode={setFindingAltSubcode}
                setShowBillingSettings={setShowBillingSettings}
            />
            <FindClientDialog
                dialogName={DialogList.FIND_CLIENT}
                hideDialog={hideDialog}
                clients={clients}
                setClientSearchTerm={setClientSearchTerm}
                onCancel={onCancel}
                style={{maxHeight: '50vw'}}
                setSelectedClient={setSelectedClient}
            />
            {!!selectedClient && !!selectedProject && <FindSubcodeDialog
                project={selectedProject}
                client={selectedClient}
                dialogName={DialogList.FIND_SUBCODE}
                hideDialog={hideDialog}
                addNewSubcode={addingSubcode}
                subcodeTypes={subcodeTypes}
                subcodes={subcodes}
            />}
            <FindProjectDialog
                dialogName={DialogList.FIND_PROJECT}
                hideDialog={hideDialog}
                setProjectSearchTerm={setProjectSearchTerm}
                onCancel={onCancel}
                style={{maxHeight: '50vw'}}
                addNewProject={addingSubcode}
                setSelectedProject={setSelectedProject}
                setSelectedClient={setSelectedClient}
                mileageRate={currentMileageRate}
                onAddNewProject={AddProjectAndHideDialog}
                clientNumber={selectedClient?.clientNumber}
                dayRate={getDayRate()}
                clientTypes={projectTypes}
            />
            <WarningDialog
                message={getWarningDialogMessage()}
                heading={'Info'}
                dialogName={DialogList.WARNING}
                hideDialog={hideDialog}
                label={getWarningDialogLabel()}
                handleConfirm={onHandleConfirmClosureRequest}
                handleCancellation={hideDialog}
            />
            <InvoiceGroupingDialog
                dialogName={DialogList.INVOICE_GROUPING}
                showEditInvoiceGroupDialog={() => showDialog(DialogList.EDIT_INVOICE_GROUP)}
                hideDialog={hideDialog}
                showDialog={showDialog}
                client={selectedClient}
                project={selectedProject}
                subCodes={igSubcodes}
                handleClosureRequest={onHandleClosureRequest}
                setCreatingInvoiceGroup={setCreatingGroup}
                setInvoiceGroup={setInvoiceGroup}
            />
            <EditInvoiceGroupNameDialog
                dialogName={DialogList.EDIT_INVOICE_GROUP}
                hideDialog={hideDialog}
                handleConfirm={handleConfirmEditInvoiceGroup}
                invoiceGroup={invoiceGroup}
                create={creatingGroup}
                projectId={selectedProject?.id}
            />
        </>
    );
};

export default SubcodeMaintenancePage;



// WEBPACK FOOTER //
// ./src/components/client-project/pages/SubcodeMaintenancePage.tsx